module.exports = __webpack_public_path__ + "img/0e29c21.jpg";